import React from 'react'

export default function SelectieButtonEnumReadonly({
  type,
  options,
  selected,
  onChange,
  readonly,
}) {
  return (
    <div>
      <label key={type}>
        <select
          className='styled-select'
          disabled={readonly}
          value={selected} //zorgt er voor dat wij ook in code kunnen bepalen wat de waarde moet zijn, zoals het terug zetten naar "geen"
          onChange={onChange}
        >
          {options.map((opt: number) => (
            <option key={opt} value={opt}>
              {type[opt]}
            </option>
          ))}
          ;
        </select>
      </label>
    </div>
  )
}
